import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useFetchAuthorisation, useFetchUserData } from '../../utils/AppFunctions'
import config from '../../app-config'
import 'react-toastify/dist/ReactToastify.css'
import AdminLayout from '../../layouts/AdminLayout'
import { MdAdd, MdCheck, MdClose, MdEdit } from 'react-icons/md'
import DataTable from '../../components/ui/DataTable'
import Button from '../../components/ui/Button'
import notify from '../../utils/IANotification'

export default function WebsitePoliciesPage() {
  const navigate = useNavigate()
  useFetchAuthorisation("user")
  useFetchUserData()

  const [policies, setPolicies] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchPolicies()
  }, [])

  const fetchPolicies = async () => {
    setLoading(true)
    try {
      const res = await fetch(config.endpoint + "/config", {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      })
      const data = await res.json()
      if (data.status === 200) {
        setPolicies(data?.data?.policy || [])
      }
    } catch (err) {
      notify({ message: "Failed to load policies", type: "error" })
    }
    setLoading(false)
  }

  const table_columns = [
    {
      header: "Policy Name",
      accessor: "name",
    },
    {
      header: "Published",
      accessor: "is_published",
      modifier: (val) => val !== "0" && val !== false
        ? <span className="inline-flex items-center gap-1 text-emerald-700 font-semibold text-xs"><MdCheck /> Published</span>
        : <span className="inline-flex items-center gap-1 text-amber-700 font-semibold text-xs"><MdClose /> Draft</span>
    },
  ]

  return (
    <AdminLayout
      navSelected={"Policies"}
      toolbar={
        <>
          <h1 className='text-lg font-semibold text-gray-900'>Church Policies</h1>
          <button
            className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors duration-200 gap-2"
            onClick={() => navigate("/admin/website/policies/details?policy_id=new")}
          >
            <MdAdd size={16} />
            New Policy
          </button>
        </>
      }
    >
      {loading ? (
        <div className="flex-row items-center flex justifyCenter w-100">
          <h1>Loading...</h1>
        </div>
      ) : (
        <div className="w-100">
          <DataTable
            columns={table_columns}
            data={policies}
            enableActions
            actions={(row) => (
              <div className="flex gap-2">
                <Button
                  variant="outline"
                  size="sm"
                  icon={MdEdit}
                  onClick={() => navigate(`/admin/website/policies/details?policy_id=${row.id || row.identifier}`)}
                >
                  Edit
                </Button>
              </div>
            )}
          />
        </div>
      )}
    </AdminLayout>
  )
}
